const worksite = {
  "page": {
    "loading": "កំពុងផ្ទុកទំព័រ...",
  },
  "panel": {
    "membersTitle": "កម្មករដែលបានតភ្ជាប់",
    "membersEmpty": "គ្មានកម្មករកំពុងតភ្ជាប់ទេ",
    "membersCount": "សរុប {{count}} នាក់",
    "refreshMembers": "ផ្ទុកទីតាំងកម្មករឡើងវិញ",
    "unknownPosition": "មិនស្គាល់ទីតាំង",
    "pollingDegraded": "ការតភ្ជាប់មានការពន្យារ — កំពុងបង្ហាញទិន្នន័យចុងក្រោយ",
  },
  "role": {
    "owner": "ម្ចាស់",
    "inspector": "អ្នកត្រួតពិនិត្យ",
    "viewer": "អ្នកមើល",
  },
  "relative": {
    "justNow": "អម្បាញ់មិញ",
    "minutesAgo": "{{value}} នាទីមុន",
    "hoursAgo": "{{value}} ម៉ោងមុន",
    "daysAgo": "{{value}} ថ្ងៃមុន",
    "unknown": "-",
  },
  "member": {
    "role": "តួនាទី",
    "lastReported": "របាយការណ៍ទីតាំងចុងក្រោយ",
    "accuracy": "ភាពត្រឹមត្រូវ GPS",
    "violationState": "ស្ថានភាពការបំពាន",
    "violationNone": "ធម្មតា",
    "closeCard": "បិទកាតព័ត៌មានលម្អិត",
  },
  "violation": {
    "badge": "បំពាន",
    "toast": "{{name}} — បំពានតំបន់ហាមឃាត់ {{zone}}",
    "unknownZone": "តំបន់ហាមឃាត់",
  },
  "marker": {
    "ariaLabel": "សញ្ញាសម្គាល់កម្មករ {{label}}",
    "violationSpoken": "កំពុងបំពានតំបន់ហាមឃាត់",
  },
  "layers3d": {
    "title": "ស្រទាប់",
    "mesh": "Mesh",
    "loading": "កំពុងផ្ទុកស្រទាប់ 3D...",
    "empty": "គ្មានស្រទាប់ 3D (Mesh·BIM·GIS) ដើម្បីបង្ហាញទេ",
    "emptyModels": "គ្មានស្រទាប់ 3D (Mesh·BIM) ដើម្បីបង្ហាញទេ",
    "loadFailed": "មិនអាចផ្ទុកបានទេ",
    "count": "សរុប {{count}}",
  },
  "zones": {
    "manage": "គ្រប់គ្រងតំបន់ហាមឃាត់",
    "count": "សរុប {{count}}",
    "empty": "មិនមានតំបន់ហាមឃាត់ដែលបានចុះឈ្មោះទេ",
    "draw": "គូរតំបន់ហាមឃាត់ថ្មី",
    "drawingHint":
      "ចុចលើផែនទីដើម្បីដាក់ចំណុច រួចចុចទ្វេដងដើម្បីបញ្ចប់។ ចុច ESC ឬចុចម៉ៅស្តាំដើម្បីបោះបង់។",
    "drawCancel": "បោះបង់ការគូរ",
    "rename": "ប្តូរឈ្មោះ",
    "renameInput": "ឈ្មោះរបស់ {{name}}",
    "renameConfirm": "រក្សាទុកឈ្មោះរបស់ {{name}}",
    "renameCancel": "បោះបង់ការប្ដូរឈ្មោះ {{name}}",
    "delete": "លុប",
    "rowMenu": "ម៉ឺនុយ {{name}}",
    "active": "សកម្ម",
    "deleteConfirmTitle": "លុបតំបន់ហាមឃាត់",
    "deleteConfirmMessage": "លុបតំបន់ '{{name}}' ឬ?",
    "deleteConfirmSub": "មិនអាចត្រឡប់វិញបានទេ។",
    "cancel": "បោះបង់",
  },
  "zoneDialog": {
    "createTitle": "ឈ្មោះតំបន់ហាមឃាត់ថ្មី",
    "renameTitle": "ប្តូរឈ្មោះតំបន់ហាមឃាត់",
    "nameLabel": "ឈ្មោះតំបន់",
    "confirm": "បញ្ជាក់",
    "cancel": "បោះបង់",
    "tooFewPoints": "សូមដាក់ចំណុចយ៉ាងតិច 3",
  },
  "error": {
    "presencePoll": "មិនអាចទាញយកកម្មករដែលបានតភ្ជាប់ — កំពុងព្យាយាមម្តងទៀតដោយស្វ័យប្រវត្តិ",
    "presenceLoad": "មិនអាចផ្ទុកបញ្ជីកម្មករដែលកំពុងភ្ជាប់បានទេ",
    "projectNoLocation": "ទីតាំងនេះមិនមានព័ត៌មានទីតាំងសម្រាប់បង្ហាញលើផែនទីទេ",
    "projectLoad": "មិនអាចផ្ទុកព័ត៌មានទីតាំងបានទេ",
    "zonesLoad": "មិនអាចទាញយកបញ្ជីតំបន់ហាមឃាត់បានទេ",
    "zoneCreate": "ការបង្កើតតំបន់ហាមឃាត់បានបរាជ័យ",
    "zoneUpdate": "ការកែប្រែតំបន់ហាមឃាត់បានបរាជ័យ",
    "zoneDelete": "ការលុបតំបន់ហាមឃាត់បានបរាជ័យ",
    "noPermission": "អ្នកមិនមានសិទ្ធិទេ",
  },
} as const;

export default worksite;
